import { render } from "./HomeLayout.vue?vue&type=template&id=3bfc9cb7"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__